<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchOEEItemsManagement"
      >
        <template #start>
          <vs-button
            v-if="isUserCanAccessMenu(permission.name, 'add')"
            class="button shadow-primary font-semibold"
            color="primary"
            @click="onHandlePopUp()"
          >
            Add L1 Item
          </vs-button>
          <vs-button
            class="button shadow-secondary font-semibold ml-5"
            color="secondary"
            @click="isDownload = true"
            :disabled="isDownload"
          >
            Export Excel
          </vs-button>
        </template>
      </table-top>
      <data-table
        class="mt-6"
        :table-header="header"
        :table-data="flattenedData"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        :loading="isBusy"
        body-height="80vh"
      >
        <template #action="{ row }">
          <div class="flex flex-row justify-end gap-x-3">
            <div
              v-if="row.level !== 'L3' && isUserCanAccessMenu(permission.name, 'add')"
              class="p-1 w-8 h-8 self-center flex items-center justify-center bg-secondary rounded cursor-pointer"
              @click="() => onHandlePopUp({
                parent_id: row.id,
                parent_name: row.name,
                level: row.level === 'L1' ? 'L2' : 'L3',
              })"
            >
              <vs-icon
                icon="add_circle_outline"
                color="#fff"
                size="22px"
              />
            </div>
            <div
              v-if="isUserCanAccessMenu(permission.name, 'edit')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="() => onHandlePopUp(row)"
            >
              <img :src="require('@/assets/shipo-icon-edit.svg')">
            </div>
            <div
              v-if="isUserCanAccessMenu(permission.name, 'delete')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="() => onHandlePopUpDelete(row)"
            >
              <img :src="require('@/assets/shipo-icon-delete.svg')">
            </div>
          </div>
        </template>
        <template #name="{ row }">
          <div
            class="flex justify-start gap-3 cursor-pointer"
            @click="row.hasChildren ? toggleRow(row) : null"
          >
            <div
              v-if="row.hasChildren"
              :class="[
                'self-center flex items-center justify-center bg-primary rounded',
                row.level === 'L2' ? 'ml-4' : '',
                row.level === 'L3' ? 'ml-8' : ''
              ]"
            >
              <vs-icon
                :icon="expandedRowsList.includes(row.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
                color="white"
                size="16px"
              />
            </div>
            <div
              v-else
              class="w-6"
            />
            <div
              :class="[
                !row.hasChildren && row.level === 'L2' ? 'ml-4' : '',
                !row.hasChildren && row.level === 'L3' ? 'ml-8' : '',
                row.hasChildren ? 'font-bold' : ''
              ]"
            >
              {{ row.name || '-' }}
            </div>
          </div>
        </template>
        <template #level="{ row }">
          <div>
            {{ row.level || '-' }}
          </div>
        </template>
        <template #code="{ row }">
          <div>
            {{ row.code || '-' }}
          </div>
        </template>
        <template #type="{ row }">
          <div>
            {{ row.type || '-' }}
          </div>
        </template>
        <template #column_as="{ row }">
          <div>
            {{ row.column_as || '-' }}
          </div>
        </template>
        <template #row_as="{ row }">
          <div>
            {{ row.row_as || '-' }}
          </div>
        </template>
        <template #remark="{ row }">
          <div>
            {{ row.remark || '-' }}
          </div>
        </template>
      </data-table>
      <table-bottom 
        class="mt-7"
        @fetch="fetchOEEItemsManagement" 
      />
    </div>
    <o-e-e-item
      :active.sync="oeeItemPopUp.active"
      :data="oeeItemPopUp.data"
      @fetch="fetchOEEItemsManagement"
    />
    <delete-o-e-e-item
      :active.sync="oeeItemPopUpDelete.active"
      :data="oeeItemPopUpDelete.data"
      @fetch="fetchOEEItemsManagement"
    />
  </div>
</template>

<script>
import {mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'
import downloadUtils from '@/utils/downloadUtils'
import DeleteOEEItem from '@/views/masterData/keyActivityStatus/OEEItemsManagement/DeleteOEEItem'
import OEEItem from '@/views/masterData/keyActivityStatus/OEEItemsManagement/OEEItem'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    DataTable,
    TableTop,
    TableBottom,
    OEEItem,
    DeleteOEEItem
  },
  data() {
    return {
      isBusy: false,
      isDownload: false,
      header: [
        { key: 'action', label: 'Action', sortable: false, width: '75px' },
        { key: 'name', label: 'Name'},
        { key: 'level', label: 'Level', sortable: false, width: '80px' },
        { key: 'code', label: 'Code' },
        { key: 'type', label: 'Type', sortable: false, width: '120px' },
        { key: 'column_as', label: 'Column as', sortable: false },
        { key: 'row_as', label: 'Row as', sortable: false },
        { key: 'remark', label: 'Remark', sortable: false }
      ],
      datas: [],
      expandedRowsList: [],
      filters: {
        sort_by: '',
        sort_dir: ''
      },
      oeeItemPopUp: {
        active: false,
        data: null
      },
      oeeItemPopUpDelete: {
        active: false,
        data: null
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      oeeItems: 'OEEItemsManagement/OEEItemsManagement',
      oeeItemsFiles: 'OEEItemsManagement/OEEItemsManagementFiles'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    },
    flattenedData() {
      const result = []
      this.datas.forEach(item => {
        // Add the parent item
        result.push({
          id: item.id,
          parent_id: item.parent_id,
          parent_name: item.parent_name,
          name: item.name,
          level: item.level,
          code: item.code,
          type: item.type,
          column_as: item.column_as,
          row_as: item.row_as,
          remark: item.remark,
          hasChildren: item.hasChildren,
          isParent: true
        })
        
        // Add children if expanded
        if (this.expandedRowsList.includes(item.id) && item.children) {
          item.children.forEach(child => {
            result.push({
              id: child.id,
              parent_id: child.parent_id,
              parent_name: child.parent_name,
              name: child.name,
              level: child.level,
              code: child.code,
              type: child.type,
              column_as: child.column_as,
              row_as: child.row_as,
              remark: child.remark,
              hasChildren: child.hasChildren,
              isChild: true
            })
            
            // Add L3 children if L2 is expanded
            if (this.expandedRowsList.includes(child.id) && child.children) {
              child.children.forEach(grandChild => {
                result.push({
                  id: grandChild.id,
                  parent_id: grandChild.parent_id,
                  parent_name: grandChild.parent_name,
                  name: grandChild.name,
                  level: grandChild.level,
                  code: grandChild.code,
                  type: grandChild.type,
                  column_as: grandChild.column_as,
                  row_as: grandChild.row_as,
                  remark: grandChild.remark,
                  hasChildren: grandChild.hasChildren,
                  isGrandChild: true
                })
              })
            }
          })
        }
      })
      return result
    }
  },
  watch: {
    isDownload: {
      handler(val) {
        if (val) {
          this.downloadOEEItemsManagement()
        }
      }
    },
    oeeItemsFiles: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `OEE Items.xlsx`)
          // Reset the export file state
          this.$store.dispatch('OEEItemsManagement/resetOEEItemsManagementFiles');
        }
      }
    }
  },
  mounted() {
    this.fetchOEEItemsManagement()
  },
  methods: {
    async fetchOEEItemsManagement() {
      try {
        this.isBusy = true
        const apiFilters = {
          sort_dir: this.filters.sort_dir || 'asc',
          sort_by: this.filters.sort_by || 'name',
          page: this.currentPage || 1,
          limit: this.pageSize || 10
        };

        await this.$store.dispatch('OEEItemsManagement/fetchOEEItemsManagement', apiFilters)
        const normalized = this.normalizeHierarchy(this.oeeItems || [])
        this.datas = Array.isArray(normalized) ? normalized : []

        this.isAdding = false
        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch OEE Items Management list, please try again')
      }
    },
    normalizeHierarchy(items, parentName) {
      if (!Array.isArray(items)) return []

      const looksHierarchical = items.some(i => Array.isArray(i.children))
      if (looksHierarchical) {
        return items.map(item => ({
          id: item.id,
          parent_id: item.parent_id,
          parent_name: parentName || null,
          name: item.name,
          level: item.level,
          code: item.code,
          type: item.type,
          column_as: item.column_as,
          row_as: item.row_as,
          remark: item.remark,
          children: this.normalizeHierarchy(item.children || [], item.name),
          hasChildren: Array.isArray(item.children) && item.children.length > 0
        }))
      }
    },
    toggleRow(row) {
      const index = this.expandedRowsList.indexOf(row.id);
      if (index > -1) {
        this.expandedRowsList.splice(index, 1); // Collapse
      } else {
        this.expandedRowsList.push(row.id); // Expand
      }
    },
    onHandlePopUp(data) {
      this.oeeItemPopUp.active = true
      this.oeeItemPopUp.data = data || null
    },
    onHandlePopUpDelete(data) {
      this.oeeItemPopUpDelete.active = true
      this.oeeItemPopUpDelete.data = data || null
    },
    async downloadOEEItemsManagement() {
      try {
        this.isBusy = true
        await this.$store.dispatch('OEEItemsManagement/downloadOEEItemsManagement', {
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          responseType: 'blob'
        });
        this.isDownload = false;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.isDownload = false;
        this.showFailedNotification(this, 'Failed to download OEE Items Management, please try again');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  @apply bg-primary;
  border-radius: 0.5rem;

  &.complete {
    background-color: #D1F9E3;
  }

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}

.icon-disable-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  border-radius: 0.5rem;

  background-color: #64646433;
}

.badge-status {
  background-color: #4CAF5033;
  color: #4CAF50;
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;

  &.inactive {
    background-color: #DB111133;
    color: #DB1111;
  }
}
</style>
